<template>
    <div>
       
        <Editaddress/>
    </div>
</template>
<script>
import Editaddress from '@/components/Editaddress'
export default {
     components: {      
        Editaddress
     },
    
     data: () => ({
            name: 'Edit Delivery Address',
            
      }),
      mounted(){
           this.$parent.$children[0].$parent.ttlval = this.name
      },
      
}
</script>
<style scoped>

</style>